<div class="details-card-wrapper">
    <!-- heading -->
    <h2>Description</h2>

    <div class="details-card">
        <div class="details-card-body">
            <div class="card-description" [innerHTML]="truncatedResult().displayText | safeHtml"></div>

            <!-- Read More Section -->
            @if (truncatedResult().plainTextLength > MAX_CHARACTERS_TO_SHOW) {
            <div class="view-more-section d-flex flex-row justify-content-end">
                <div class="view-more-content">
                    @if (!isExpanded) {
                    <span (click)="toggleViewMoreComments()" class="view-more">View More</span>
                    }

                    <!-- for View Less -->
                    @if (isExpanded) {
                    <span (click)="toggleViewMoreComments()" class="view-more">View Less</span>
                    }
                </div>
            </div>
            }
        </div>
    </div>
</div>